// extracted by mini-css-extract-plugin
export default {"wrapper":"Advt_wrapper__eYGxf","logo":"Advt_logo__511P6","title":"Advt_title__vb5ex","qrBlock":"Advt_qrBlock__q07qE","qrCode":"Advt_qrCode__AIZN4"};